import { apiGet, apiPost, apiUpload } from './client';
import type {
  ConversationDetailView,
  ConversationView,
  CreateGroupInput,
  MessagePage,
  MessageView,
  SendMessageInput,
  SuggestedGroupView,
} from './chat.types';
import type { SocialUser } from './community.types';
import { isSocialMockEnabled } from '../featureFlags';
import { mockChatApi } from '../mock/social';

/** Ảnh đã thu nhỏ + nén ở trình duyệt (screens/chat/prepareImage.ts). */
export interface ImageUpload {
  blob: Blob;
  width: number;
  height: number;
}

const realChatApi = {
  listConversations: () => apiGet<ConversationView[]>('/chat/conversations'),
  getConversation: (conversationId: string) => apiGet<ConversationDetailView>(`/chat/conversations/${conversationId}`),
  /** Tin mới nhất trước; `cursor` = nextCursor của trang trước để tải tin cũ hơn. */
  getMessages: (conversationId: string, cursor?: string | null) =>
    apiGet<MessagePage>(`/chat/conversations/${conversationId}/messages${cursor ? `?cursor=${encodeURIComponent(cursor)}` : ''}`),
  sendMessage: (conversationId: string, input: SendMessageInput) =>
    apiPost<MessageView>(`/chat/conversations/${conversationId}/messages`, input),
  sendImage: (conversationId: string, image: ImageUpload) => {
    const form = new FormData();
    form.append('file', image.blob, 'image.jpg');
    form.append('width', String(image.width));
    form.append('height', String(image.height));
    return apiUpload<MessageView>(`/chat/conversations/${conversationId}/images`, form);
  },
  markRead: (conversationId: string) => apiPost<{ unread: number }>(`/chat/conversations/${conversationId}/read`),
  getUnread: () => apiGet<{ unread: number }>('/chat/unread'),
  /** Idempotent: đã có DM với người này thì trả lại hội thoại cũ. */
  openDm: (userId: string) => apiPost<ConversationView>('/chat/dm', { userId }),
  getSuggestedGroups: () => apiGet<SuggestedGroupView[]>('/chat/groups/suggested'),
  createGroup: (input: CreateGroupInput) => apiPost<ConversationView>('/chat/groups', input),
  joinGroup: (conversationId: string) => apiPost<ConversationView>(`/chat/groups/${conversationId}/join`),
  /** Người có thể mời vào nhóm. */
  getContacts: () => apiGet<SocialUser[]>('/chat/contacts'),
};

export const chatApi: typeof realChatApi = isSocialMockEnabled() ? mockChatApi : realChatApi;
